import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { Route, Link, withRouter, Redirect, useHistory } from "react-router-dom"
import LoadingOverlay from "./general/loadingOverlay"
import Overlay from "./general/overlay"
import classNames from "classnames"
import MobileMenuButton from "components/MobileMenuButton"
import { loadingStatus, setActiveProperties, getPayload, setViewAs } from "../actions"
import settings from "settings"

import Dashboard from "./entry/dashboard"
import ARC from "./entry/arc"
import WebLeads from "./entry/webLeads"
import ARCSubmitMaster from "./entry/arcSubmitMaster"
import ARCEditMaster from "./entry/arcEditMaster"
import Account from "./general/account"
import NewTraffic from "./entry/forms/traffic"
import EditTraffic from "./entry/editTraffic"
const EntryLotMap = React.lazy(() => import("./reports/entryLotMap"))
const ActivityCalendar = React.lazy(() => import("./entry/activityCalendar"))
import ThankYouCancel from "./entry/thankyou/cancel"
import LotStatus from "./reports/lotStatus"
import Traffic from "./entry/dashboards/traffic"
import EditSale from "./entry/editSale"
import ThankYouSale from "./entry/thankyou/sale"
import ThankYouClosing from "./entry/thankyou/closing"
import ThankYouTraffic from "./entry/thankyou/traffic"
import LotInventory from "./entry/lot-inventory"
import Floorplans from "./entry/floorplans"
import Floorplan from "./entry/floorplan"
import Competition from "./entry/competition"
import ReactSelect from "components/ReactSelect"
import ViewAs from "components/ViewAs"
import WeeklyReport from "./reports/weekly"
import { compose } from "redux"
import axios from "axios"
import _ from "lodash"
import helpers from "helpers/helpers"
import Modal from "react-responsive-modal"
import NoActivityModal from "./entry/modals/noActivity"
import submitData from "helpers/submitData"
import { toast } from "react-toastify"
import currentUser from "helpers/currentUser"
var jwtDecode = require("jwt-decode")

class Entry extends Component {
	constructor(props) {
		super(props)
		this.state = {
			invalid: false, // making sure managers can't login to entry section
			noActivityModal: false,
			navOpen: false,
			viewAs: false,
			viewAsID: 0,
			nav: [
				{
					title: "DASHBOARD",
					icon: "fa-tachometer-alt",
					link: "/entry/dashboard",
				},
				{
					title: "LOT INVENTORY",
					icon: "fa-usd-circle",
					link: "/entry/lot-inventory",
				},
				{
					title: "LOT STATUS",
					icon: "fa-map-marked-alt",
					link: "/entry/lot-status",
				},
				{
					title: "LOT MAP",
					icon: "fa-map-marker-check",
					link: "/entry/lot-map",
				},
				{
					title: "TRAFFIC",
					icon: "fa-walking",
					link: "/entry/traffic",
				},
				...(settings?.disabled?.entryLeads?.includes(2)
					? []
					: [
							{
								title: "LEADS",
								icon: "fa-envelope-open-text",
								link: "/entry/leads",
							},
					  ]),
				{
					title: "ACTIVITY CALENDAR",
					icon: "fa-calendar-week",
					link: "/entry/activity-calendar",
				},
				{
					title: settings.weekly && settings.weekly.summary ? `SALES REPORT` : "WEEKLY REPORT",
					icon: "fa-chart-mixed",
					link: "/entry/weekly-report",
				},
			],
			user: currentUser(),
			showProperties: [`/entry/weekly-report`, `/entry/lot-status`, `/entry/competition`], // This will show the active properties dropdown
		}
	}

	componentDidMount() {
		// Check that this is a salesperson and not a manager
		let user = localStorage.getItem("user")
		user = jwtDecode(user)
		// Check to ensure this is a salesperson
		if (user.group !== 13 && !this.state.user.viewAs) {
			localStorage.removeItem("user")
			window.location.href = "/logout"
		}
		let activeProperties = localStorage.getItem("activeProperties")
		// Viewing as admin
		if (activeProperties && localStorage.getItem("viewAs")) {
			this.props.setActiveProperties(JSON.parse(activeProperties))
		} else if (user.activeProperties && user.aud == 1) {
			// Viewing as salesperson directly - no view as
			this.props.setActiveProperties(user.activeProperties)
		}
		if (localStorage.getItem("viewAs")) {
			let sp = jwtDecode(localStorage.getItem("viewAs"))
			this.props.setViewAs(sp.id)
		}
		this.props.getPayload()
	}

	componentDidUpdate() {
		// This is for builders with multiple properties.  On any report except weekly, put their activeproperties back to their assignments.  This is only modified on weeky report so htey can choose which property they want.
		if (
			this.state.user.group === 13 &&
			!this.state.user.viewAs &&
			this.state.user.activeProperties.length !== this.props.activeProperties.length &&
			!this.state.showProperties.includes(window.location.pathname)
		) {
			this.changeProperties(this.state.user.activeProperties)
		}
	}

	renderNav() {
		let user = currentUser()
		// use the third array item to determine where we are in the entry section
		var pathArray = window.location.pathname.split("/")
		var classNames = require("classnames")
		let nav = _.cloneDeep(this.state.nav)
		if (settings.optionalEntryModules && settings.optionalEntryModules.length > 0) {
			nav = _.concat(nav, settings.optionalEntryModules)
		}
		try {
			//? Special logic for the Lot Map.  Sometimes devs have this turned off for salespeople EXCEPT their own builder/devloper salespeople, like Caldwell Homes
			if (
				_.get(settings, `enabled.entryBuilderDeveloperLotMap`) &&
				!user.builders.includes(this.props.payload.public.options.developerBuilder)
			) {
				// Dev map is enabled but this user isn't a developer builder, so remove
				nav = _.remove(nav, (r) => r.title !== "LOT MAP")
			} else if (
				_.get(settings, `enabled.entryBuilderDeveloperLotMap`) &&
				user.builders.includes(this.props.payload.public.options.developerBuilder)
			) {
				// Skip this condition.  DevBuilder is on and this user is a dev builder
			} else if (_.get(settings, `disabled.entryLotMap`)) {
				// Special case if lotmap is disalbed, but dev map is enabled, check for that.
				nav = _.remove(nav, (r) => r.title !== "LOT MAP")
			}
			//? Some developers just want lot inventory with website admin...SRR
			if (settings.builderPortalOnlyMarketing && !user.viewAs) {
				nav = [
					{
						title: "LOT INVENTORY",
						icon: "fa-usd-circle",
						link: "/entry/lot-inventory",
					},
				]
			} else if (settings.builderPortalMarketingAndARC && !user.viewAs) {
				nav = [
					{
						title: "LOT INVENTORY",
						icon: "fa-usd-circle",
						link: "/entry/lot-inventory",
					},
					{
						title: "Floorplans",
						icon: "fa-notebook",
						link: "/entry/floorplans",
					},
					{
						title: "ARC PORTAL",
						icon: "fa-upload",
						link: "/entry/arc",
					},
				]
			}
		} catch (e) {
			console.log(e)
		}

		return nav.map((r, i) => {
			var path = r.link.split("/")
			var here = path[2] == pathArray[2] ? true : false
			var classes = classNames("body__navItem", {
				here: here,
			})
			return (
				<li key={i} className={classes} onClick={this.toggleMobileMenu}>
					<Link to={r.link}></Link>
					<div className="body__navTitle">
						<i className={`fas ${r.icon} fa-2x`}></i>
						<span>{r.title}</span>
					</div>
				</li>
			)
		})
	}

	backtoAdmin = () => {
		localStorage.removeItem("viewAs")
		this.props.setViewAs(0)
	}

	changeUser = (v) => {
		let userToken = localStorage.getItem("user")
		axios
			.post(
				settings.ep + "/generateViewAsToken",
				{ id: v, activeProperties: this.props.activeProperties },
				{
					headers: { Authorization: `Bearer ${userToken}` },
				}
			)
			.then((response) => {
				localStorage.setItem("viewAs", response.data.token)
				// Check what the person they want to view as is.
				let find = _.find(this.props.payload.users, { id: v })
				let viewAsID = find ? find.group : null
				this.props.setViewAs(v)
				this.setState({ viewAs: true, viewAsID })
				this.props.getPayload()
			})
			.catch((error) => {
				// need error handling
				this.props.loadingStatus(false)
			})
	}

	viewAsBack = () => {
		if (localStorage.getItem("viewAs")) {
			let url = localStorage.getItem("currentPath") ? localStorage.getItem("currentPath") : "/"
			return (
				<li onClick={this.backtoAdmin}>
					<Link to={url} className="flex h-full items-center">
						Back to Admin
					</Link>
				</li>
			)
		}
	}

	viewAsName = () => {
		if (localStorage.getItem("viewAs")) {
			let salesperson = _.find(this.props.payload.public.salespeople, { id: this.props.viewAs })
			if (!salesperson) {
				return
			}
			return (
				<span className="viewAs__name">
					Viewing as: {salesperson.first} {salesperson.last}
				</span>
			)
		}
	}

	viewAsSelect = () => {
		if (localStorage.getItem("viewAs")) {
			return (
				<li>
					<div className="top__viewAs">
						<p className="top__selectTitle">View As:</p>
						<ViewAs
							options={helpers.listViewAsUsers(
								this.props.payload.users,
								this.props.payload.public.builders,
								this.props.activeProperties
							)}
							value={this.props.viewAs}
							onChange={(v) => this.changeUser(v)}
							onBlur={() => {}}
							className="top__select"
							classNamePrefix="multiSelect"
							clearable
						/>
					</div>
				</li>
			)
		}
	}

	requestHelp = () => {
		if (localStorage.getItem("viewAs")) {
			//return
		}
		if (!this.props.payload.salespersonPayload.help) {
			return
		}
		return (
			<>
				<p className="portal__help">
					Need help?
					<br />
				</p>
				<p className="portal__help">
					<a href={`mailto:${this.props.payload.salespersonPayload.help}`}>REQUEST HELP</a>
				</p>
			</>
		)
	}

	listProperties = (v) => {
		let users = helpers.bothUsers()
		if (
			users.admin.activeProperties &&
			typeof users.admin.activeProperties == "object" &&
			users.admin.activeProperties.length > 0
		) {
			let arr = []
			_.forEach(this.props.payload.public.properties, (v) => {
				if (users.admin.activeProperties.includes(v.id)) {
					arr.push({
						value: v.id,
						label: v.name,
					})
				}
			})
			arr = _.sortBy(arr, "label")
			return arr
		}
		return []
	}

	getNewToken = async (properties) => {
		let userToken = localStorage.getItem("user")
		await axios
			.post(
				settings.ep + "/generateViewAsToken",
				{ id: this.props.viewAs, activeProperties: properties },
				{
					headers: { Authorization: `Bearer ${userToken}` },
				}
			)
			.then((response) => {
				localStorage.setItem("viewAs", response.data.token)
			})
	}

	changeProperties = async (v) => {
		if (!v) {
			v = []
		}
		let f = []
		for (let r of v) {
			f.push(r)
		}
		if (f.length == 0) {
			localStorage.removeItem("activeProperties")
		} else {
			localStorage.setItem("activeProperties", JSON.stringify(f))
		}

		this.props.setActiveProperties(f)
		// If this is a viewAs, we need to get a new token because getData pulls the viewas token which has active props.
		if (this.props.viewAs) {
			let sp = jwtDecode(localStorage.getItem("viewAs"))
			if (sp && Array.isArray(sp.activeProperties)) {
				sp.activeProperties = v
				await this.getNewToken(f)
			}
			this.props.getPayload() // moved this to only view as to prevent as it shouldn't be needed for salespeople
		}
	}

	viewAs = () => {
		let user = currentUser()
		if (
			localStorage.getItem("viewAs") ||
			(user.group === 13 &&
				this.state.showProperties.includes(window.location.pathname) &&
				user.activeProperties.length > 1)
		) {
			return (
				<div className="top__propertyPicker">
					<p className="top__selectTitle">Active Properties:</p>
					<ReactSelect
						isMulti
						options={this.listProperties()}
						value={this.props.activeProperties}
						onChange={(a, b) => this.changeProperties(b)}
						onBlur={() => {}}
						className="top__select"
						classNamePrefix="multiSelect"
					/>
				</div>
			)
		} else {
			return <div></div>
		}
	}

	inputNoActivity = () => {
		submitData("inputNoActivity")
			.then((data) => {
				toast.success(data.message)
				this.setState({ noActivityModal: false })
			})
			.catch((e) => {
				toast.error(e.message)
			})
	}

	emailCommunityManagers = () => {
		if (this.props.payload.salespersonPayload.communityManagers) {
			return (
				<a
					className="portal__communityManagers"
					href={`mailto:${this.props.payload.salespersonPayload.communityManagers}`}>
					Need Help? Email Us
				</a>
			)
		}
	}

	reportNoActivity = () => {
		if (!this.props.payload.salespersonPayload.noActButton) {
			return
		}
		return (
			<div
				className="portal__noActivityButton"
				onClick={() => {
					this.setState({ noActivityModal: true })
				}}>
				Report No Weekly Activity
			</div>
		)
	}

	displayPortalLinks = () => {
		let ret = []
		_.forEach(this.props.activeProperties, (prop) => {
			let check = _.find(this.props.payload.public.properties, { id: prop })
			if (check && check.portal_links && check.portal_links.length > 0) {
				// This property has portal links
				let i = 0
				_.forEach(check.portal_links, (v) => {
					ret.push(
						<li className={v.color} key={i}>
							<a href={v.link} target="_blank">
								{v.title}
							</a>
						</li>
					)
					i++
				})
			}
		})

		let f = <ul className="portal__sideNav portal__sideNav--links">{ret}</ul>

		return f
	}

	displayGlobalAlert = () => {
		let check = {}
		let overridden = false
		try {
			// Check global first, then check individual property messages
			let override = this.props.payload.public.override_portal_message
			if (override) {
				_.forEach(override, (v) => {
					if (
						v.properties &&
						v.properties.length > 0 &&
						_.intersection(v.properties, this.props.activeProperties).length > 0 &&
						Date.now() / 1000 > v.start_date &&
						Date.now() / 1000 < v.end_date
					) {
						overridden = true
						check.message = v.message
						check.color = v.color
					} else if (
						(!v.properties || v.properties.length === 0) &&
						Date.now() / 1000 > v.start_date &&
						Date.now() / 1000 < v.end_date
					) {
						overridden = true
						check.message = v.message
						check.color = v.color
					}
				})
			}
			if (!overridden && !check.message) {
				let property = _.find(this.props.payload.public.properties, { id: this.props.activeProperties[0] })
				if (property && property.portal_message) {
					check.message = property.portal_message
				}
			}
		} catch (e) {
			console.log(e)
		}
		if (check.message) {
			return (
				<div
					className={classNames("globalAlert", {
						[`globalAlert--${check.color}`]: overridden,
					})}>
					<div className="c">
						<p dangerouslySetInnerHTML={{ __html: check.message }}></p>
					</div>
				</div>
			)
		} else return ""
	}

	toggleMobileMenu = (r) => {
		if (r.path === false) {
			return
		}
		this.setState({
			navOpen: !this.state.navOpen,
		})
	}

	displayInterface = () => {
		return (
			<>
				{this.displayGlobalAlert()}
				<div className="globalCont c">
					<div className="top">
						<div className="top__logo">
							<Link to="/entry/dashboard">
								<img src={settings.logo} alt="Pipsy" className="top__logoImg" />
							</Link>
							<div onClick={this.toggleMobileMenu}>
								<MobileMenuButton />
							</div>
						</div>
						<div className="top__global">
							{this.viewAs()}
							<div>
								<ul className="top__globalList">
									{this.viewAsBack()}
									{this.viewAsSelect()}
									{/*<li><i className="far fa-bell"></i></li>*/}
									<li>
										<Link to="/entry/account">
											<i className="far fa-user-cog"></i>
										</Link>
									</li>
									<li>
										<Link to="/logout">
											<i className="far fa-power-off"></i>
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div className="body">
						<div className="body__nav">
							<ul
								className={classNames("body__navList", {
									active: this.state.navOpen,
								})}>
								<li className="body__mobileClose" onClick={this.toggleMobileMenu}>
									<i className="far fa-times-octagon" />
								</li>
								<li className="body__mobileLogo">
									<img src="/img/logo.svg" alt="Pipsy" />
								</li>
								{this.renderNav()}
							</ul>
							<div className="portal__sideNav">
								{this.reportNoActivity()}
								{this.emailCommunityManagers()}
								{!settings.arc && !_.get(settings, `disabled.entrySubmitFloorplan`) && (
									<a href={`mailto:${settings.corporateContact}?subject=New Floor Plan Request`}>
										Submit New Floor Plan
									</a>
								)}
							</div>
							<div className="portal__portalLinks">{this.displayPortalLinks()}</div>
						</div>
						<div className="body__stageCont">
							<div className="body__stage" id="stage">
								<Route path="/entry/account" exact component={Account} />
								<Route path="/entry/dashboard" exact component={withRouter(Dashboard)} />
								<Route path="/entry/lot-inventory" exact component={withRouter(LotInventory)} />
								<Route path="/entry/lot-map" exact component={withRouter(EntryLotMap)} />
								<Route path="/entry/sales/thankyou" exact component={ThankYouSale} />
								<Route path="/entry/weekly-report" exact component={WeeklyReport} />
								<Route path="/entry/floorplans" exact component={Floorplans} />
								<Route path="/entry/sales/edit/:id" component={EditSale} />
								<Route path="/entry/floorplan/:id" component={Floorplan} />
								<Route path="/entry/cancels/thankyou" exact component={ThankYouCancel} />
								<Route path="/entry/traffic" exact component={Traffic} />
								<Route path="/entry/lot-status" exact component={LotStatus} />
								<Route path="/entry/competition" exact component={Competition} />
								<Route path="/entry/leads" exact component={WebLeads} />
								<Route path="/entry/arc" exact component={ARC} />
								<Route path="/entry/activity-calendar" exact component={ActivityCalendar} />
								<Route path="/entry/arc/new" exact component={ARCSubmitMaster} />
								<Route path="/entry/arc/edit/:id" exact component={ARCEditMaster} />
								<Route path="/entry/traffic/edit/:id" component={EditTraffic} />
								<Route path="/entry/traffic/new-traffic" exact component={NewTraffic} />
								<Route path="/entry/traffic/thankyou" exact component={ThankYouTraffic} />
								<Route path="/entry/closings/thankyou" exact component={ThankYouClosing} />
							</div>
						</div>
					</div>
					<p className="body__issues">
						Issues or comments? Email us at{" "}
						<a href={`mailto:${settings.issueEmail}`}>{settings.issueEmail}</a> |{" "}
						<a href="https://www.pipsy.io">Pipsy</a> | Master Planned Community Engine | Made in Texas
					</p>
					<LoadingOverlay />
					<Overlay />
					<Modal
						classNames={{ modal: "modalForm" }}
						open={this.state.noActivityModal}
						onClose={() => this.setState({ noActivityModal: false })}
						center>
						<NoActivityModal notify={this.inputNoActivity} name="noActivityModal" />
					</Modal>
				</div>
			</>
		)
	}

	render() {
		if (this.state.invalid) {
			return <Redirect to={"/login"} />
		} else if (this.state.viewAs) {
			// Go through and check what type of user this is
			if (this.state.viewAsID === 14) {
				return <Redirect to={`/arc`} />
			} else if (this.state.viewAsID === 2) {
				return <Redirect to={`/salesManager/dashboard`} />
			} else if (this.state.viewAsID === 15) {
				return <Redirect to={`/superintendent/lot-inventory`} />
			}
			return this.displayInterface()
			//return <Redirect to={"/entry/dashboard"} />
		} else {
			return this.displayInterface()
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		payload: state.payload,
		viewAs: state.viewAs,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
			setViewAs,
			setActiveProperties,
		},
		dispatch
	)
}

export default compose(connect(mapStateToProps, matchDispatchToProps))(Entry)
